module.exports = __webpack_public_path__ + "img/about2.3f1a6cda.webp";